module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/sumRightBg-ada9a9d8a3b312465f242893e013aa21.png";